import { render, staticRenderFns } from "./simditor.vue?vue&type=template&id=3b6521e4&"
import script from "./simditor.vue?vue&type=script&lang=js&"
export * from "./simditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports